@if(universalService.selectedNodes.length == 0) {
   
    @if(params.isCustomToolTipRequired) {
        <div id="custom-tooltip">
            <div class="hd">
                <div class="thumbnail-name">
                    @if (object.format == 'Document' || object.format == 'SpreadSheet' || object.format == 'Presentation' || object.format == 'MSOfficeDocument') {
                      <span class="document-container">
                          <img class="img-fluid icon-tile ms-document-tile" loading="lazy" src="{{object.MSOfficeImage}}" data-toggle="tooltip" alt="" />
                        </span>
                      } 
                      
                      @else if (object.format == 'image' || object.format == 'audio') {
                        <span class="{{object.iconName}} icon-tile"></span>
                      }

                      @else if (object.format == 'video') {
                        <span class="img-icon-container">
                          <img draggable="false" class="img-fluid icon-tile ms-document-tile" src="assets/images/video.svg" data-toggle="tooltip" alt="" />
                        </span>
                      }

                      @else if (object.format == 'pdf' || object.format == 'PDF') {
                        <span class="pdf-container">
                          <img class="img-fluid icon-tile ms-document-tile" loading="lazy" src="/assets/images/pdf.svg" data-toggle="tooltip" alt="" />
                        </span>
                      } @else if (object.format == 'text') {
                        <span class="txt-container">
                            <img class="img-fluid icon-tile ms-document-tile" loading="lazy" src="/assets/images/txt.svg" data-toggle="tooltip" alt="" />
                        </span>
                      } @else {
                        <span class="NeueOtherFiles icon-tile"></span>
                      }
                    <span class="file-name">{{object.objectShortName}}</span>
                </div>
            </div>
            <div class="bd">
                @if (this.object.defaultThumbnailRequired) {
                <div class="grid_file_child default-thumbnail-icon {{object.defaultIconClassName}}" data-toggle="tooltip">
                    @if (object.format == 'image' || object.format == 'audio') {
                    <span class="{{object.iconName}} position-absolute"></span>
                    } 
                    
                    @if (object.format == 'video') {
                        <img draggable="false" class="img-fluid img-thumbnail ms-document-tile" src="assets/images/video.svg" data-toggle="tooltip" alt="" />
                    }
                </div>
                }
                
                @if (object.format == 'Document' || object.format == 'SpreadSheet' || object.format == 'Presentation' || object.format
                == 'MSOfficeDocument') {
                <div class="grid_file_child default-thumbnail-icon default-thumbnail-background" data-toggle="tooltip">
                    <img draggable="false" class="img-fluid img-thumbnail ms-document-tile" loading="lazy"
                        src="{{object.MSOfficeImage}}" data-toggle="tooltip" alt="" />
                </div>
                } @else if (object.format == 'pdf' || object.format == 'PDF') {
                <div class="grid_file_child default-thumbnail-icon default-thumbnail-background" data-toggle="tooltip">
                    <img class="img-fluid img-thumbnail pdf-document-tile" loading="lazy" src="/assets/images/pdf.svg"
                        data-toggle="tooltip" alt="" />
                </div>
                } @else if (object.format == 'text') {
                    <div class="grid_file_child default-thumbnail-icon default-thumbnail-background" data-toggle="tooltip">
                        <img class="img-fluid img-thumbnail text-document-tile" loading="lazy" src="/assets/images/txt.svg" data-toggle="tooltip" alt="" />
                    </div>
                  } @else if (object.format == 'application') {
                    <div class="grid_file_child default-thumbnail-icon default-thumbnail-background" data-toggle="tooltip">
                        <span class="NeueOtherFiles icon-tile"></span>
                    </div>
                  }
                @if(object.imageTranscodeUrl && object.imageTranscodeUrl.includes("&apiKey") ) {
                    <img class="img-fluid img-thumbnail" [ngClass]="object.format == 'audio' ? 'audio-thumbnail' : ''" loading="lazy"  src='{{this.object.imageTranscodeUrl}}' alt="" (error)="thumbnailError($event)" />
                }
            </div>
        </div>
    } @else {
        <div id="default-name-tooltip">
            @if(this.params && (this.params["tooltipReqFor"] == 'owner' || this.params["tooltipReqFor"] == 'sharedBy' || this.params["tooltipReqFor"] == 'createdByName')){
              {{this.params.value}}
            }@else{
              {{object.objectName}}
            } 
        </div>
    }
}